module.exports = __webpack_public_path__ + "static/services1-2120af7d5995e19f5501c8f2fa24f6a9.jpg";